import { render, staticRenderFns } from "./StudentHistory.vue?vue&type=template&id=6d9b02b5&scoped=true"
import script from "./StudentHistory.vue?vue&type=script&lang=js"
export * from "./StudentHistory.vue?vue&type=script&lang=js"
import style0 from "./StudentHistory.vue?vue&type=style&index=0&id=6d9b02b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9b02b5",
  null
  
)

export default component.exports